/* eslint-disable import/first, import/newline-after-import */

import(/* webpackChunkName: 'collection-util-modal', webpackPreload: true */ 'components/collections/collection-util-modal');
import(/* webpackChunkName: 'collections-modal', webpackPreload: true */ 'components/collections/collections-modal/collections-modal');
import(/* webpackChunkName: 'collections-search-form', webpackPreload: true */ 'components/collections/collections-search-form/collections-search-form');
import(/* webpackChunkName: 'collections-privacy-control', webpackPreload: true */ 'components/collections/collections-privacy-control/collections-privacy-control');
import(/* webpackChunkName: 'collections-alert', webpackPrefetch: true */ 'components/collections/collections-alert/collections-alert');

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import CollectionSaveButtonController from 'collections/save_button_component/collection-save-button-controller';
EezyStimulusApplication.register('collection-save-button', CollectionSaveButtonController);

import(/* webpackChunkName: "collections-modal-controller" */ 'components/collections/collections-modal/collections-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('collections-modal', controller.default);
  });

import(/* webpackChunkName: "collections-modal-form-controller" */ 'components/collections/collections-modal/collections-modal-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('collections-modal-form', controller.default);
  });

import(/* webpackChunkName: "collections-search-form-controller" */ 'components/collections/collections-search-form/collections-search-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('collections-search-form', controller.default);
  });

import(/* webpackChunkName: "collections-privacy-control-controller" */ 'components/collections/collections-privacy-control/collections-privacy-control-controller')
  .then((controller) => {
    EezyStimulusApplication.register('collections-privacy-control', controller.default);
  });

import(/* webpackChunkName: "collections-alert-controller" */ 'components/collections/collections-alert/collections-alert-controller')
  .then((controller) => {
    EezyStimulusApplication.register('collections-alert', controller.default);
  });
